import API from '../lib/API';
import { ListClientDevice } from './contracts/ClientDeviceServiceContract';

const route = '/clientDevice';

export function listClientDevice(): Promise<ListClientDevice.Response> {
    return API.get(route);
};
